<template>
  <div class="customer-list-page">
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />

    <!-- Server Error State -->
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>

    <!-- Main Content -->
    <v-layout v-else wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12 pa-5>

        <!-- Page Header -->
        <div class="page-header mb-5">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon color="white" size="22">mdi-store</v-icon>
            </div>
            <div>
              <h2 class="page-title">Active Sellers</h2>
            </div>
            <div class="stat-chip ml-3" v-if="totalData">
              <v-icon size="14" color="#3ea56e">mdi-store-check-outline</v-icon>
              <span>{{ totalData }} Sellers</span>
            </div>
          </div>
          <div class="header-right">
            <v-btn
              outlined
              color="#e53935"
              class="text-capitalize action-top-btn"
              href="/pendingSeller"
            >
              <v-icon left small>mdi-clock-outline</v-icon>
              Pending Sellers
            </v-btn>
            <download-excel :data="json_data" :fields="json_fields" style="display: inline-block;">
              <v-btn
                depressed
                dark
                color="#3ea56e"
                class="text-capitalize action-top-btn"
              >
                <v-icon left small>mdi-file-excel</v-icon>
                Download Excel
              </v-btn>
            </download-excel>
          </div>
        </div>

        <!-- Main Card -->
        <v-card class="modern-card" elevation="0">

          <!-- Card Toolbar -->
          <div class="card-toolbar">
            <div class="toolbar-left">
              <v-icon color="#3ea56e" class="mr-2">mdi-format-list-bulleted</v-icon>
              <span class="toolbar-title">Sellers Directory</span>
            </div>
            <div class="toolbar-right">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                placeholder="Search sellers..."
                outlined
                dense
                hide-details
                clearable
                class="search-field"
                style="min-width: 260px;"
              ></v-text-field>
            </div>
          </div>

          <v-divider></v-divider>

          <!-- Data Table -->
          <v-data-table
            :headers="headers"
            :items="user"
            :items-per-page="count"
            hide-default-footer
            class="modern-table"
          >
            <!-- Name Column with Avatar -->
            <template v-slot:[`item.firstname`]="{ item }">
              <div class="user-cell">
                <div class="user-avatar">
                  {{ getInitials(item.firstname, item.lastname) }}
                </div>
                <div class="user-name-wrap">
                  <span class="user-fullname">{{ item.firstname }} {{ item.lastname }}</span>
                </div>
              </div>
            </template>

            <!-- Username Column -->
            <template v-slot:[`item.username`]="{ item }">
              <span class="username-chip">@{{ item.username }}</span>
            </template>

            <!-- Phone Column -->
            <template v-slot:[`item.phone`]="{ item }">
              <div class="contact-cell">
                <v-icon size="13" color="#9e9e9e" class="mr-1">mdi-phone-outline</v-icon>
                <span>{{ item.phone }}</span>
              </div>
            </template>

            <!-- Email Column -->
            <template v-slot:[`item.email`]="{ item }">
              <div class="contact-cell">
                <v-icon size="13" color="#9e9e9e" class="mr-1">mdi-email-outline</v-icon>
                <span>{{ item.email }}</span>
              </div>
            </template>

            <!-- Organization Column -->
            <template v-slot:[`item.organization`]="{ item }">
              <div class="contact-cell">
                <v-icon size="13" color="#9e9e9e" class="mr-1">mdi-domain</v-icon>
                <span style="font-weight: 500;">{{ item.organization || '—' }}</span>
              </div>
            </template>

            <!-- Actions Column -->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="action-btns">
                <v-btn
                  icon
                  small
                  class="action-btn view-btn"
                  @click="sellerinfo(item._id)"
                  title="View Details"
                >
                  <v-icon size="16">mdi-eye-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  class="action-btn edit-btn"
                  @click="edit(item._id)"
                  title="Edit Seller"
                >
                  <v-icon size="16">mdi-pencil-outline</v-icon>
                </v-btn>
              </div>
            </template>

            <!-- Empty State -->
            <template v-slot:no-data>
              <div class="empty-state">
                <v-icon size="56" color="#e0e0e0">mdi-account-search-outline</v-icon>
                <p class="empty-title">No sellers found</p>
                <p class="empty-subtitle">Try adjusting your search query</p>
              </div>
            </template>
          </v-data-table>

          <!-- Pagination -->
          <div class="pagination-wrap" v-if="pages > 1">
            <div class="pagination-info">
              <span>Page {{ currentPage }} of {{ pages }}</span>
            </div>
            <v-pagination
              :length="pages"
              :total-visible="7"
              v-model="currentPage"
              color="#3ea56e"
              class="modern-pagination"
            ></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      search: "",
      currentPage: 1,
      ServerError: false,
      pages: 0,
      count: 20,
      totalData: 0,
      totalRows: 0,
      headers: [
        { text: "Name", value: "firstname" },
        { text: "Username", value: "username" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Organization", value: "organization" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      json_fields: {
        FirstName: "firstname",
        LastName: "lastname",
        Email: "email",
        Phone: "phone",
        Pincode: "pincode",
        Organization: "organization",
        BankName: "seller.bankname",
        Branch: "seller.branch",
        AccountNumber: "seller.accountnumber",
        IFSCcode: "seller.ifsccode",
        AccountHolder: "seller.accountholder",
        GSTID: "seller.gstid",
        OwnerName: "seller.ownername",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      user: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    },
    search() {
      this.currentPage = 1;
      this.getData();
    },
  },
  methods: {
    getInitials(firstname, lastname) {
      const f = firstname ? String(firstname).charAt(0).toUpperCase() : "";
      const l = lastname ? String(lastname).charAt(0).toUpperCase() : "";
      return f + l || "?";
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/seller/activeall",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          keyword: this.search,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.json_data = this.user;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    sellerinfo(sid) {
      this.$router.push("/SellerInfonew?seller=" + sid);
    },
    edit(sid) {
      this.$router.push("/editSeller?seller=" + sid);
    },
  },
};
</script>

<style scoped>
/* ── Page Wrapper ── */
.customer-list-page {
  background: #f5f6fa;
  min-height: 100vh;
}

/* ── Page Header ── */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.action-top-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  height: 38px !important;
}
.header-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3ea56e, #2d8257);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.35);
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  line-height: 1.2;
}
.stat-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #e8f5e9;
  border: 1px solid #c8e6c9;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #2d8257;
}

/* ── Main Card ── */
.modern-card {
  border-radius: 16px !important;
  border: 1px solid #ebebeb !important;
  overflow: hidden;
  background: #ffffff;
}

/* ── Card Toolbar ── */
.card-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 18px 20px;
  background: #ffffff;
}
.toolbar-left {
  display: flex;
  align-items: center;
}
.toolbar-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}
.search-field ::v-deep .v-input__slot {
  border-radius: 10px !important;
  font-size: 13px;
}

/* ── Data Table ── */
.modern-table ::v-deep thead th {
  background: #f9fafb !important;
  color: #6b7280 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.6px !important;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 14px 16px !important;
}
.modern-table ::v-deep tbody tr {
  transition: background 0.18s ease;
  cursor: pointer;
}
.modern-table ::v-deep tbody tr:hover {
  background: #f0fdf4 !important;
}
.modern-table ::v-deep tbody td {
  font-size: 13px;
  color: #374151;
  padding: 13px 16px !important;
  border-bottom: 1px solid #f5f5f5 !important;
}

/* ── User Cell (Avatar + Name) ── */
.user-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #3ea56e22, #3ea56e44);
  color: #2d8257;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1.5px solid #3ea56e33;
}
.user-fullname {
  font-weight: 600;
  color: #1f2937;
  font-size: 13px;
}

/* ── Username Chip ── */
.username-chip {
  background: #f3f4f6;
  border-radius: 6px;
  padding: 3px 9px;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  font-family: monospace;
}

/* ── Contact Cell ── */
.contact-cell {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #4b5563;
}

/* ── Action Buttons ── */
.action-btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.action-btn {
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}
.view-btn {
  background: #e8f5e9 !important;
  color: #2d8257 !important;
}
.view-btn:hover {
  background: #3ea56e !important;
  color: #fff !important;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(62, 165, 110, 0.35) !important;
}
.edit-btn {
  background: #e3f2fd !important;
  color: #1565c0 !important;
}
.edit-btn:hover {
  background: #1976d2 !important;
  color: #fff !important;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(25, 118, 210, 0.3) !important;
}

/* ── Empty State ── */
.empty-state {
  padding: 48px 20px;
  text-align: center;
}
.empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #9e9e9e;
  margin: 12px 0 4px;
}
.empty-subtitle {
  font-size: 13px;
  color: #bdbdbd;
  margin: 0;
}

/* ── Pagination ── */
.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 14px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}
.pagination-info {
  font-size: 12px;
  color: #9e9e9e;
  font-weight: 500;
}
.modern-pagination ::v-deep .v-pagination__item {
  border-radius: 8px !important;
  font-size: 13px !important;
  min-width: 34px !important;
  height: 34px !important;
  box-shadow: none !important;
}
.modern-pagination ::v-deep .v-pagination__navigation {
  border-radius: 8px !important;
  box-shadow: none !important;
}
</style>
